import { ongoingCourses } from 'components/organisms/UpDashboard/constants';
import CourseList from '../../CourseList';

export default function Ongoing() {
  return <CourseList courses={ongoingCourses} />;
}
